enum ApplePayMerchantCapabilitiesTypes {
  SUPPORTS_3DS = 'supports3DS',
  SUPPORTS_CREDIT = 'supportsCredit',
  SUPPORTS_DEBIT = 'supportsDebit',
  SUPPORTS_EMV = 'supportsEMV',
}

enum ApplePayLineItemTypes {
  FINAL = 'final',
  PENDING = 'pending',
}

export const MERCHANT_CAPABILITIES = [ApplePayMerchantCapabilitiesTypes.SUPPORTS_3DS]

export const SUPPORTED_NETWORKS = ['visa', 'masterCard', 'amex']

export const MERCHANT_LABEL = {
  label: 'Stayforlong',
  type: ApplePayLineItemTypes.FINAL,
}
